import StatusBadge, { StatusTone } from "@buildpy/ui/status-badge";
import { CHANGE_ORDER_STATUS_LABEL, type ChangeOrderStatus } from "@buildpy/core/modules/change-order/types";

// 상태 → 톤. 톤표는 components/status-badge 와 디자인 시스템 StatusBadge 표를 따른다.
export const CHANGE_ORDER_STATUS_TONE: Record<ChangeOrderStatus, StatusTone> = {
  DRAFT: "hold",
  SENT: "progress",
  ACCEPTED: "done",
  REJECTED: "dropped",
  VOID: "dropped",
};

interface Props {
  status: ChangeOrderStatus;
  className?: string;
}

const ChangeOrderStatusBadge = ({ status, className }: Props) => (
  <StatusBadge className={className} label={CHANGE_ORDER_STATUS_LABEL[status]} tone={CHANGE_ORDER_STATUS_TONE[status]} />
);

export default ChangeOrderStatusBadge;
